import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import { Form, Formik } from "formik";
import Button from "../component-lib/Molecules/button/Button";
import { CUSTOM_lABEL_STYLE } from "../screens/patient-screen/visit-flow/constant";
import Heading from "../component-lib/Atoms/heading/EventEHRHeading";
import useDeviceType from "../custom-hooks/DeviceType";
import SelectDropdown from "../component-lib/Atoms/Select/Select";
import { TRANSFER_TO_CLINIC_LOCATION_DISPOSITION_DATA } from "./constants";
import { useDispatch, useSelector } from "react-redux";
import { getFacilities } from "../screens/patient-screen/patientSaga";
import {
  componentKey,
  setBundleOrderData,
} from "../screens/patient-screen/patientSlice";
import BundleOrderModal from "../screens/patient-screen/visit-flow/dialogs/BundleOrderModal";
import BundleOrderDisplay from "../screens/patient-screen/visit-flow/dialogs/BundelOrderDisplay";

interface ClinicLocationFormProps {
  getFormData: (data: any) => void;
  // Offsite dispositions have no clinical care — hide the bundle-order action.
  isOffsite?: boolean;
}

export default function TransferToClinicLocationForm({
  getFormData,
  isOffsite = false,
}: ClinicLocationFormProps) {
  const { facilityData } = useSelector((state: any) => state[componentKey]);
  const [bundleModalOpen, setBundleModalOpen] = useState(false);
  const facilityDataList = facilityData?.map((data: any) => ({
    label: data?.name,
    value: data?.id,
  }));
  const dispatch = useDispatch();
  const deviceType = useDeviceType();

  const validationSchema = Yup.object().shape({
    [TRANSFER_TO_CLINIC_LOCATION_DISPOSITION_DATA.CLINIC_LOCATION]:
      Yup.string().required("Base camp is required"),
  });

  useEffect(() => {
    try {
      dispatch(getFacilities({ isBaseCamp: true }));
    } catch (error) {
      console.log("error", error);
    }
  }, []);

  return (
    <>
      <Formik
        initialValues={{
          [TRANSFER_TO_CLINIC_LOCATION_DISPOSITION_DATA.CLINIC_LOCATION]: "",
        }}
        validationSchema={validationSchema}
        enableReinitialize
        onSubmit={(values, { setSubmitting }) => {
          try {
            getFormData(values);
          } catch (error) {
            console.log(error);
          } finally {
            setSubmitting(false); // Reset submitting state
          }
        }}
      >
        {({
          errors,
          values,
          touched,
          isValid,
          dirty,
          setFieldValue,
          handleBlur,
          handleSubmit,
        }) => {
          return (
            <Form onSubmit={handleSubmit}>
              <div
                className="h-full flex flex-col justify-between gap-6"
                style={{
                  height: deviceType === "mobile" ? "40vh" : "fit-content",
                  overflow: "auto",
                }}
              >
                {/* Type of Transfer DROPDOWN */}
                <div>
                  <Heading
                    title="Base Camp"
                    customStyle={CUSTOM_lABEL_STYLE}
                  />
                  <SelectDropdown
                    label=""
                    displayEmpty={true}
                    placeholderValue={"Select Base Camp"}
                    value={
                      values[
                        TRANSFER_TO_CLINIC_LOCATION_DISPOSITION_DATA
                          .CLINIC_LOCATION
                      ]
                    }
                    options={facilityDataList}
                    onChangeCb={(e: any) =>
                      setFieldValue(
                        TRANSFER_TO_CLINIC_LOCATION_DISPOSITION_DATA.CLINIC_LOCATION,
                        e.target.value
                      )
                    }
                    error={
                      touched[
                        TRANSFER_TO_CLINIC_LOCATION_DISPOSITION_DATA
                          .CLINIC_LOCATION
                      ] &&
                      Boolean(
                        errors[
                          TRANSFER_TO_CLINIC_LOCATION_DISPOSITION_DATA
                            .CLINIC_LOCATION
                        ]
                      )
                    }
                    helperText={
                      touched[
                        TRANSFER_TO_CLINIC_LOCATION_DISPOSITION_DATA
                          .CLINIC_LOCATION
                      ]
                        ? errors[
                            TRANSFER_TO_CLINIC_LOCATION_DISPOSITION_DATA
                              .CLINIC_LOCATION
                          ]
                        : undefined
                    }
                  />
                </div>
              </div>
              <BundleOrderDisplay/>
              {/* ACTION BUTTONS */}
              <div className="mt-9 text-end flex gap-2 justify-end">
                {!isOffsite && (
                  <Button
                    type="button"
                    label="Create Bundle Order"
                    variant="outlined"
                    onClickCb={() => {
                      setBundleModalOpen(true);
                    }}
                    style={{
                      padding: "8px 24px",
                      fontSize: "16px",
                      borderColor: "#1976d2",
                      color: "#1976d2",
                      backgroundColor: "white",
                      marginRight: "12px",
                    }}
                  />
                )}
                <Button
                  // disabled={!isValid} // Button disabled if form is invalid or submitting
                  type="submit"
                  label="Submit"
                  variant="contained"
                  onClickCb={() => {}}
                  style={{
                    padding: "8px 55px",
                    fontSize: "16px",
                  }}
                ></Button>
              </div>
            </Form>
          );
        }}
      </Formik>

      <BundleOrderModal
        open={bundleModalOpen}
        handleClose={() => setBundleModalOpen(false)}
        handleSave={(data) => {
          console.log("Bundle Order Data:", data);
          dispatch(setBundleOrderData(data));
          setBundleModalOpen(false);
        }}
      />
    </>
  );
}
